import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, catchError, of, tap } from 'rxjs';
import { UserPermissionsService } from '../services/user-permissions.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  private userPermissions = inject(UserPermissionsService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const permission = route.data['permission'] as string | undefined;
    const permissions = route.data['permissions'] as string[] | undefined;

    const hasAccess$ = permission
      ? this.userPermissions.hasPermission(permission)
      : permissions?.length
        ? this.userPermissions.hasAnyPermission(permissions)
        : of(true);

    return hasAccess$.pipe(
      tap(ok => {
        if (!ok) {
          this.router.navigate(['/unauthorized'], { queryParams: { returnUrl: state.url } });
        }
      }),
      catchError(() => {
        this.router.navigate(['/unauthorized'], { queryParams: { returnUrl: state.url } });
        return of(false);
      })
    );
  }
}
